import { useContext } from 'react';
import { OfflineStateContext } from './OfflineStateContext';

/**
 * Hook to use offline state context
 */
export function useOfflineState() {
  const context = useContext(OfflineStateContext);
  if (context === undefined) {
    throw new Error('useOfflineState must be used within an OfflineStateProvider');
  }
  return context;
}
